// Purely decorative radial glow, positioned via the useSpotlight hook's
// pos/active state. Does not intercept pointer events.
export const SpotlightGlow = ({ pos, active, size = 460 }) => {
  return (
    <div
      className="pointer-events-none absolute inset-0 z-[5] transition-opacity duration-300"
      style={{ opacity: active ? 1 : 0 }}
      data-testid="cursor-spotlight-glow"
    >
      <div
        className="absolute rounded-full"
        style={{
          left: pos.x,
          top: pos.y,
          width: size,
          height: size,
          transform: 'translate(-50%, -50%)',
          background: 'radial-gradient(circle, hsl(var(--lxra-gold) / 0.18) 0%, hsl(var(--lxra-gold) / 0.05) 40%, transparent 70%)',
        }}
      />
    </div>
  );
};
